import {makeGetServicesDentalGuide, makeGetServicesMedicalGuide} from 'main/factories/usecases';
import {PlanTypeEnum} from 'presentation/constants';
import {GetServicesGuideParams} from './types';

export async function getServicesGuide({type, cdUf, nmCidade, signal}: GetServicesGuideParams) {
	if (type === PlanTypeEnum.HEALTH) {
		const response = await makeGetServicesMedicalGuide().get({
			cdUf,
			nmCidade,
			signal,
		});
		if (!response.servicos || response.servicos.length === 0) {
			return [];
		}
		return response.servicos;
	}

	const response = await makeGetServicesDentalGuide().get({
		cdUf,
		nmCidade,
		signal,
	});
	if (!response.servicos || response.servicos.length === 0) {
		return [];
	}
	return response.servicos;
}
